//# sourceMappingURL=setup.mjs.map
/// <reference types="./setup.d.mts" />
import * as $remote from "../../../../data_types/data/remote.mjs";
import * as $tag from "../../../../data_types/data/tag.mjs";
import * as $colors from "../../../../ds/ds/colors.mjs";
import * as $button from "../../../../ds/ds/components/button.mjs";
import * as $checkbox from "../../../../ds/ds/components/checkbox.mjs";
import * as $input from "../../../../ds/ds/components/input.mjs";
import * as $label from "../../../../ds/ds/components/label.mjs";
import * as $l from "../../../../ds/ds/components/layout.mjs";
import * as $modal from "../../../../ds/ds/components/modal.mjs";
import * as $skeleton from "../../../../ds/ds/components/skeleton.mjs";
import * as $typography from "../../../../ds/ds/components/typography.mjs";
import * as $icons from "../../../../ds/ds/icons.mjs";
import * as $text from "../../../../ds/ds/typography/text.mjs";
import * as $promise from "../../../../gleam_javascript/gleam/javascript/promise.mjs";
import * as $bool from "../../../../gleam_stdlib/gleam/bool.mjs";
import * as $float from "../../../../gleam_stdlib/gleam/float.mjs";
import * as $int from "../../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../../gleam_stdlib/gleam/option.mjs";
import * as $pair from "../../../../gleam_stdlib/gleam/pair.mjs";
import * as $string from "../../../../gleam_stdlib/gleam/string.mjs";
import * as $timestamp from "../../../../gleam_time/gleam/time/timestamp.mjs";
import * as $random from "../../../../prng/prng/random.mjs";
import * as $redraw from "../../../../redraw/redraw.mjs";
import * as $event from "../../../../redraw/redraw/event.mjs";
import * as $ref from "../../../../redraw/redraw/ref.mjs";
import * as $compose from "../../../../redraw_batteries/redraw/batteries/compose.mjs";
import * as $a from "../../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $e from "../../../../redraw_dom/redraw/dom/events.mjs";
import * as $h from "../../../../redraw_dom/redraw/dom/html.mjs";
import * as $css from "../../../../sketch/sketch/css.mjs";
import * as $length from "../../../../sketch/sketch/css/length.mjs";
import { px } from "../../../../sketch/sketch/css/length.mjs";
import * as $sh from "../../../../sketch_redraw/sketch/redraw/dom/html.mjs";
import * as $function from "../../../../tiamat/tiamat/function.mjs";
import * as $organization_setup_effects from "../../../admin/effects/organization_setup.mjs";
import * as $card from "../../../components/card.mjs";
import * as $msg from "../../../data/msg.mjs";
import * as $store from "../../../data/store.mjs";
import { Ok, toList, Empty as $Empty, isEqual } from "../../../gleam.mjs";
import * as $common from "../../../view/common.mjs";

function setup_default_config() {
  return $redraw.component_(
    "SetupDefaultConfig",
    (_) => {
      let $ = $redraw.use_state(new $checkbox.Unchecked());
      let checked = $[0];
      let set_checked = $[1];
      let store = $store.use_state();
      let dispatch = $store.use_dispatch();
      let dispatch$1 = (m) => { return dispatch(new $msg.OrganizationSetup(m)); };
      let on_setup_click = $e.on_click(
        (_) => {
          dispatch$1(new $msg.UserClickedSetup());
          return undefined;
        },
      );
      let ai_config = $store.organization_ai_config(store);
      let disabled = $remote.is_loaded(ai_config);
      let _block;
      if (disabled) {
        _block = $l.styles(toList([$css.none()]));
      } else {
        _block = $l.styles(toList([$css.color($colors.palette.grey_600)]));
      }
      let bypass_color = _block;
      return $card.card(
        toList([]),
        toList([
          $card.title(toList([]), toList([$h.text("Setup default config")])),
          $card.body(
            toList([]),
            toList([
              $h.text("When clicking this button, you'll setup a default "),
              $h.text(
                "configuration for the organization. No existing data should be ",
              ),
              $h.text(
                "overriden, but if the initialisation already happened, it is ",
              ),
              $h.text("deactivated by default. Run it at your own risk."),
            ]),
          ),
          $card.body(
            toList([]),
            toList([
              $l.row(
                toList([
                  $l.gap(6),
                  $l.justify("end"),
                  $l.align("center"),
                  bypass_color,
                ]),
                toList([]),
                toList([
                  $checkbox.checkbox(
                    checked,
                    !disabled,
                    (_) => {
                      return set_checked(
                        (() => {
                          if (checked instanceof $checkbox.Checked) {
                            return new $checkbox.Unchecked();
                          } else if (checked instanceof $checkbox.Unchecked) {
                            return new $checkbox.Checked();
                          } else {
                            return new $checkbox.Checked();
                          }
                        })(),
                      );
                    },
                  ),
                  $typography.text(
                    $typography.sm,
                    $typography.regular,
                    "I'm willing to take the risk",
                  ),
                ]),
              ),
            ]),
          ),
          $card.footer(
            toList([]),
            toList([
              $l.row(
                toList([$l.justify("end")]),
                toList([]),
                toList([
                  $button.primary(
                    toList([
                      on_setup_click,
                      $a.disabled(
                        disabled && (!(checked instanceof $checkbox.Checked)),
                      ),
                    ]),
                    toList([$h.text("Setup default config")]),
                  ),
                ]),
              ),
            ]),
          ),
        ]),
      );
    },
  );
}

function qualification_matrix_card() {
  return $redraw.component_(
    "QualificationMatrixCard",
    (_) => {
      let store = $store.use_state();
      return $redraw.keyed(
        (_capture) => {
          return $l.row(
            toList([$l.wrap("wrap"), $l.gap(12)]),
            toList([]),
            _capture,
          );
        },
        (() => {
          let $ = $store.organization_qm_rows(store);
          if ($ instanceof $remote.NotLoaded) {
            return toList([["loading", $skeleton.skeleton(100, 100)]]);
          } else if ($ instanceof $remote.Loading) {
            return toList([["loading", $skeleton.skeleton(100, 100)]]);
          } else if ($ instanceof $remote.Errored) {
            let error = $[0];
            return toList([
              ["error", $h.div(toList([]), toList([$h.text(error)]))],
            ]);
          } else {
            let $1 = $[0];
            if ($1 instanceof $Empty) {
              return toList([
                (() => {
                  let _pipe = $card.card(
                    toList([]),
                    toList([
                      $card.body(
                        toList([]),
                        toList([
                          $h.text(
                            "Qualification matrix has not been initialised or ",
                          ),
                          $h.text(
                            "is empty. Please initialise the tags in order to ",
                          ),
                          $h.text(
                            "edit them. At least one tag is needed in order to ",
                          ),
                          $h.text("edit the tags."),
                        ]),
                      ),
                    ]),
                  );
                  return ((_capture) => {
                    return $pair.new$("unitiliased", _capture);
                  })(_pipe);
                })(),
              ]);
            } else {
              let qm_rows = $1;
              return $list.map(
                qm_rows,
                (qm) => {
                  let _pipe = $card.card(
                    toList([]),
                    toList([
                      $card.title(toList([]), toList([$h.text(qm.title)])),
                      $card.body(toList([]), toList([$h.text(qm.content)])),
                      $card.footer(
                        toList([]),
                        toList([
                          $l.row(
                            toList([$l.justify("end"), $l.gap(6)]),
                            toList([]),
                            (() => {
                              let size = $typography.xs;
                              let weight = $typography.medium;
                              let order = $int.to_string(qm.qm_order);
                              return toList([
                                $typography.text(size, weight, "Order –"),
                                $typography.text(size, weight, order),
                              ]);
                            })(),
                          ),
                        ]),
                      ),
                    ]),
                  );
                  return ((_capture) => { return $pair.new$(qm.id, _capture); })(
                    _pipe,
                  );
                },
              );
            }
          }
        })(),
      );
    },
  );
}

function use_time_seed() {
  return $redraw.use_ref_(
    (() => {
      let _pipe = $timestamp.system_time();
      let _pipe$1 = $timestamp.to_unix_seconds(_pipe);
      let _pipe$2 = $float.round(_pipe$1);
      return $random.new_seed(_pipe$2);
    })(),
  );
}

function loading_tags(seed) {
  let seed$1 = $ref.current(seed);
  let generator = $random.int(80, 150);
  return $l.row(
    toList([$l.wrap("wrap"), $l.gap(6)]),
    toList([]),
    (() => {
      let _pipe = $list.map_fold(
        $int.range(0, 7, toList([]), $list.prepend),
        seed$1,
        (seed, _) => {
          let $ = $random.step(generator, seed);
          let width = $[0];
          let seed$1 = $[1];
          return [seed$1, $skeleton.skeleton(width, 30)];
        },
      );
      return $pair.second(_pipe);
    })(),
  );
}

function on_submit_tag(tag, set_tag, dispatch) {
  return $e.on_submit(
    (event) => {
      let _pipe = event;
      let _pipe$1 = $event.prevent_default(_pipe);
      $event.stop_propagation(_pipe$1);
      return $bool.guard(
        $string.is_empty(tag),
        undefined,
        () => {
          set_tag("");
          dispatch($organization_setup_effects.add_tag(tag));
          return undefined;
        },
      );
    },
  );
}

function add_tag_card() {
  return $redraw.component_(
    "AddTagCard",
    (_use0) => {
      let seed = _use0[0];
      let set_active_tag = _use0[1];
      let $ = $redraw.use_state("");
      let tag = $[0];
      let set_tag = $[1];
      let store = $store.use_state();
      let dispatch = $store.use_effect_dispatch();
      let tags = $store.organization_tags(store);
      let on_submit = on_submit_tag(tag, set_tag, dispatch);
      let disabled = !$remote.is_loaded(tags);
      let input_size = $l.styles(
        toList([$css.selector(" label", toList([$css.flex("1")]))]),
      );
      return $card.card(
        toList([]),
        toList([
          $card.body(
            toList([]),
            (() => {
              if (tags instanceof $remote.NotLoaded) {
                return toList([loading_tags(seed)]);
              } else if (tags instanceof $remote.Loading) {
                return toList([loading_tags(seed)]);
              } else if (tags instanceof $remote.Errored) {
                let error = tags[0];
                return toList([$h.div(toList([]), toList([$h.text(error)]))]);
              } else {
                let $1 = tags[0];
                if ($1 instanceof $Empty) {
                  return toList([
                    $l.row(
                      toList([
                        $l.styles(
                          toList([$css.compose($text.xs($text.regular))]),
                        ),
                      ]),
                      toList([]),
                      toList([
                        $h.text("Tags have not been initialised or are empty. "),
                        $h.text(
                          "Please initialise the tags in order to edit them. ",
                        ),
                        $h.text(
                          "At least one tag is needed in order to edit the tags.",
                        ),
                      ]),
                    ),
                  ]);
                } else {
                  let tags$1 = $1;
                  return toList([
                    $redraw.keyed(
                      (_capture) => {
                        return $l.row(
                          toList([$l.wrap("wrap"), $l.gap(6)]),
                          toList([]),
                          _capture,
                        );
                      },
                      $list.map(
                        tags$1,
                        (tag) => {
                          let content = $label.content(tag.name);
                          let on_click = $label.on_click(
                            () => { return set_active_tag(new Some(tag.id)); },
                          );
                          let _pipe = $label.label(
                            toList([$label.neutral(), content, on_click]),
                          );
                          return ((_capture) => {
                            return $pair.new$(tag.id, _capture);
                          })(_pipe);
                        },
                      ),
                    ),
                  ]);
                }
              }
            })(),
          ),
          $card.footer(
            toList([]),
            toList([
              $l.row(
                toList([$l.tag("form"), $l.gap(6), input_size]),
                toList([on_submit]),
                toList([
                  $input.input(
                    (() => {
                      let _pipe = $input.value(tag);
                      let _pipe$1 = $input.small(_pipe);
                      let _pipe$2 = $input.placeholder(
                        _pipe$1,
                        "Add a tag here...",
                      );
                      let _pipe$3 = $input.on_input(_pipe$2, set_tag);
                      return $input.disabled(_pipe$3, disabled);
                    })(),
                  ),
                  $button.primary(
                    toList([$a.disabled(disabled || $string.is_empty(tag))]),
                    toList([$button.content("Submit")]),
                  ),
                ]),
              ),
            ]),
          ),
        ]),
      );
    },
  );
}

function on_update_tag(tag, name, set_active_tag, dispatch) {
  return $e.on_submit(
    (event) => {
      $event.prevent_default(event);
      set_active_tag(new None());
      if (tag instanceof $remote.NotLoaded) {
        return undefined;
      } else if (tag instanceof $remote.Loading) {
        return undefined;
      } else if (tag instanceof $remote.Errored) {
        return undefined;
      } else {
        let $ = tag[0];
        if ($ instanceof Ok) {
          let tag$1 = $[0];
          let _pipe = tag$1;
          let _pipe$1 = $organization_setup_effects.update_tag(_pipe, name);
          dispatch(_pipe$1);
          return undefined;
        } else {
          return undefined;
        }
      }
    },
  );
}

function use_tag_name_input(active_tag, store) {
  let tags = $store.organization_tags(store);
  let tag = $remote.map(
    tags,
    (_capture) => {
      return $list.find(
        _capture,
        (t) => { return isEqual(new Some(t.id), active_tag); },
      );
    },
  );
  let name = $redraw.use_state(new None());
  return $function.tap(
    [tag, name[0], name[1]],
    (_use0) => {
      let set_name = _use0[2];
      return ((_capture) => {
        return $redraw.use_effect(_capture, [active_tag]);
      })(
        () => {
          if (active_tag instanceof Some && tag instanceof $remote.Loaded) {
            let $ = tag[0];
            if ($ instanceof Ok) {
              let tag$1 = $[0];
              return set_name(new Some(tag$1.name));
            } else {
              return set_name(new None());
            }
          } else {
            return set_name(new None());
          }
        },
      );
    },
  );
}

function modify_tag_card() {
  return $redraw.component_(
    "ModifyTagCard",
    (_use0) => {
      let active_tag = _use0[0];
      let set_active_tag = _use0[1];
      let store = $store.use_state();
      let dispatch = $store.use_effect_dispatch();
      let $ = use_tag_name_input(active_tag, store);
      let tag = $[0];
      let name = $[1];
      let set_name = $[2];
      let disabled = $option.is_none(name);
      let input_size = $l.styles(
        toList([$css.selector(" label", toList([$css.flex("1")]))]),
      );
      let name$1 = $option.unwrap(name, "");
      let submit_disabled = disabled || $string.is_empty(name$1);
      let on_submit = on_update_tag(tag, name$1, set_active_tag, dispatch);
      return $card.card(
        toList([$a.style(toList([["width", "100%"]]))]),
        toList([
          $card.title(toList([]), toList([$h.text("Modify tag")])),
          $card.body(toList([]), toList([])),
          $card.footer(
            toList([]),
            toList([
              $l.row(
                toList([$l.tag("form"), $l.gap(6), input_size]),
                toList([on_submit]),
                toList([
                  $input.input(
                    (() => {
                      let _pipe = $input.value(name$1);
                      let _pipe$1 = $input.small(_pipe);
                      let _pipe$2 = $input.placeholder(
                        _pipe$1,
                        "Add a tag here...",
                      );
                      let _pipe$3 = $input.on_input(
                        _pipe$2,
                        (n) => { return set_name(new Some(n)); },
                      );
                      return $input.disabled(_pipe$3, disabled);
                    })(),
                  ),
                  $button.primary(
                    toList([$a.disabled(submit_disabled)]),
                    toList([$button.content("Submit")]),
                  ),
                ]),
              ),
            ]),
          ),
        ]),
      );
    },
  );
}

function delete_tag_modal(tag, props) {
  let on_end = (b) => {
    return $e.on_click((_) => { return props.on_end(new Ok(b)); });
  };
  return $modal.modal(
    toList([]),
    toList([
      $modal.body(
        toList([]),
        toList([
          $modal.title(
            toList([]),
            toList([
              $h.text("Do you want to delete the tag "),
              $common.raw(tag.name),
              $h.text(" ?"),
            ]),
          ),
          $modal.explanations(
            toList([]),
            toList([
              $h.text("Deleting the tag is permanent, and cannot be undone. "),
              $h.text(
                "Be extra careful, as it impacts directly the content library ",
              ),
              $h.text("and the LLM responses."),
            ]),
          ),
          $modal.actions(
            toList([]),
            toList([
              $button.primary(
                toList([on_end(false)]),
                toList([$h.text("Cancel")]),
              ),
              $button.secondary(
                toList([on_end(true)]),
                toList([$h.text("Delete")]),
              ),
            ]),
          ),
        ]),
      ),
    ]),
  );
}

function on_remove_tag(tag, modal, dispatch) {
  return $e.on_click(
    (_) => {
      return $function.tap(
        undefined,
        (_) => {
          return $promise.map_try(
            modal.open(
              (_capture) => { return delete_tag_modal(tag, _capture); },
            ),
            (accepted) => {
              return $bool.guard(
                !accepted,
                new Ok(undefined),
                () => {
                  let _pipe = tag.name;
                  let _pipe$1 = $organization_setup_effects.remove_tag(_pipe);
                  dispatch(_pipe$1);
                  let _pipe$2 = undefined;
                  return new Ok(_pipe$2);
                },
              );
            },
          );
        },
      );
    },
  );
}

function delete_tag_card() {
  return $redraw.component_(
    "DeleteTagCard",
    (_use0) => {
      let seed = _use0[0];
      let active_tag = _use0[1];
      let modal = $modal.use_modal();
      let store = $store.use_state();
      let dispatch = $store.use_effect_dispatch();
      let tags = $store.organization_tags(store);
      return $card.card(
        toList([$a.style(toList([["width", "100%"]]))]),
        toList([
          $card.title(toList([]), toList([$h.text("Delete tag")])),
          $card.body(
            toList([]),
            (() => {
              if (tags instanceof $remote.NotLoaded) {
                return toList([loading_tags(seed)]);
              } else if (tags instanceof $remote.Loading) {
                return toList([loading_tags(seed)]);
              } else if (tags instanceof $remote.Errored) {
                let error = tags[0];
                return toList([$h.div(toList([]), toList([$h.text(error)]))]);
              } else {
                let $ = tags[0];
                if ($ instanceof $Empty) {
                  return toList([
                    $l.row(
                      toList([
                        $l.styles(
                          toList([$css.compose($text.xs($text.regular))]),
                        ),
                      ]),
                      toList([]),
                      toList([
                        $h.text("Tags have not been initialised or are empty. "),
                        $h.text(
                          "Please initialise the tags in order to edit them. ",
                        ),
                        $h.text(
                          "At least one tag is needed in order to edit the tags.",
                        ),
                      ]),
                    ),
                  ]);
                } else {
                  let tags$1 = $;
                  let $1 = $list.find(
                    tags$1,
                    (t) => { return isEqual(new Some(t.id), active_tag); },
                  );
                  if ($1 instanceof Ok) {
                    let tag = $1[0];
                    let state = $label.neutral();
                    let content = $label.content(tag.name);
                    return toList([
                      $l.row(
                        toList([]),
                        toList([]),
                        toList([$label.label(toList([state, content]))]),
                      ),
                    ]);
                  } else {
                    return toList([
                      $h.text("Click on a tag on your left to select it."),
                    ]);
                  }
                }
              }
            })(),
          ),
          $card.footer(
            toList([]),
            (() => {
              let tag = $remote.map(
                tags,
                (_capture) => {
                  return $list.find(
                    _capture,
                    (t) => { return isEqual(new Some(t.id), active_tag); },
                  );
                },
              );
              let _block;
              if (tag instanceof $remote.NotLoaded) {
                _block = new None();
              } else if (tag instanceof $remote.Loading) {
                _block = new None();
              } else if (tag instanceof $remote.Errored) {
                _block = new None();
              } else {
                let $ = tag[0];
                if ($ instanceof Ok) {
                  let tag$1 = $[0];
                  _block = new Some(on_remove_tag(tag$1, modal, dispatch));
                } else {
                  _block = new None();
                }
              }
              let on_remove = _block;
              let disabled = $a.disabled($option.is_none(on_remove));
              let on_remove$1 = $option.lazy_unwrap(on_remove, $e.none);
              let _pipe = $l.row(
                toList([$l.justify("end")]),
                toList([]),
                toList([
                  $button.secondary(
                    toList([disabled, on_remove$1]),
                    toList([$h.text("Delete")]),
                  ),
                ]),
              );
              return $list.wrap(_pipe);
            })(),
          ),
        ]),
      );
    },
  );
}

function tags_card() {
  return $redraw.compose(
    delete_tag_card(),
    (delete_tag_card) => {
      return $redraw.compose(
        modify_tag_card(),
        (modify_tag_card) => {
          return $redraw.compose(
            add_tag_card(),
            (add_tag_card) => {
              return $redraw.component_(
                "TagsCard",
                (_) => {
                  let seed = use_time_seed();
                  let $ = $redraw.use_state(new None());
                  let active_tag = $[0];
                  let set_active_tag = $[1];
                  return $l.row(
                    toList([$l.wrap("wrap"), $l.gap(12)]),
                    toList([]),
                    toList([
                      add_tag_card([seed, set_active_tag]),
                      modify_tag_card([active_tag, set_active_tag]),
                      delete_tag_card([seed, active_tag]),
                    ]),
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function check_icon(icon) {
  let _pipe = $css.class$(
    toList([
      $css.padding(px(4)),
      $css.border_radius(px(20)),
      $css.background($colors.palette.success_200),
      $css.color($colors.palette.success_800),
      $css.border("1px solid " + $colors.palette.success_800),
    ]),
  );
  return $sh.div(_pipe, toList([]), toList([icon]));
}

export function error_icon(icon) {
  let _pipe = $css.class$(
    toList([
      $css.padding(px(4)),
      $css.border_radius(px(20)),
      $css.background($colors.palette.error_100),
      $css.color($colors.palette.error_800),
      $css.border("1px solid " + $colors.palette.error_800),
    ]),
  );
  return $sh.div(_pipe, toList([]), toList([icon]));
}

function ai_config_info_card() {
  return $redraw.component_(
    "AIConfigInfoCard",
    (_) => {
      let store = $store.use_state();
      let ai_config = $store.organization_ai_config(store);
      return $card.card(
        toList([]),
        toList([
          $card.title(
            toList([]),
            toList([
              $l.row(
                toList([$l.align("center"), $l.justify("space-between")]),
                toList([]),
                toList([
                  $h.text("AI config"),
                  (() => {
                    if (ai_config instanceof $remote.NotLoaded) {
                      return $skeleton.skeleton(20, 20);
                    } else if (ai_config instanceof $remote.Loading) {
                      return $skeleton.skeleton(20, 20);
                    } else if (ai_config instanceof $remote.Errored) {
                      return error_icon($icons.minuscule($icons.cross()));
                    } else {
                      return check_icon($icons.minuscule($icons.check()));
                    }
                  })(),
                ]),
              ),
            ]),
          ),
          $card.body(
            toList([]),
            toList([
              (() => {
                if (ai_config instanceof $remote.NotLoaded) {
                  return $skeleton.full_width(20);
                } else if (ai_config instanceof $remote.Loading) {
                  return $skeleton.full_width(20);
                } else if (ai_config instanceof $remote.Errored) {
                  let $ = ai_config[0];
                  if ($ === "ai_config:none") {
                    return $h.text("Config has not been initialised.");
                  } else {
                    return $h.text("An error happened.");
                  }
                } else {
                  return $h.text("Configuration has already been set up.");
                }
              })(),
            ]),
          ),
        ]),
      );
    },
  );
}

export function view() {
  return $compose.static$(
    ai_config_info_card(),
    (ai_config_info_card) => {
      return $compose.static$(
        tags_card(),
        (tags_card) => {
          return $compose.static$(
            qualification_matrix_card(),
            (qualification_matrix_card) => {
              return $compose.static$(
                setup_default_config(),
                (setup_default_config) => {
                  return $redraw.component_(
                    "AiConfig(Setup)",
                    (_) => {
                      return $l.column(
                        toList([$l.gap(12)]),
                        toList([]),
                        toList([
                          $redraw.fragment(
                            toList([
                              setup_default_config(),
                              $common.underlined_title(
                                toList([]),
                                toList([$h.text("Initialise AI Config")]),
                              ),
                              ai_config_info_card(),
                              $common.underlined_title(
                                toList([]),
                                toList([$h.text("Manage Tags")]),
                              ),
                              tags_card(),
                              $common.underlined_title(
                                toList([]),
                                toList([$h.text("Qualification Matrix")]),
                              ),
                              qualification_matrix_card(),
                            ]),
                          ),
                        ]),
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function delete_icon(icon) {
  let _pipe = $css.class$(
    toList([
      $css.padding(px(4)),
      $css.border_radius(px(20)),
      $css.hover(toList([$css.cursor("pointer")])),
    ]),
  );
  return $sh.div(_pipe, toList([$a.class$("delete-icon")]), toList([icon]));
}
